<template>
  <div style="cursor: pointer;" @click="onClickBody">

    <div class="container" style="margin-left: 0.4rem; margin-right: 0.4rem;">
      <div class="number" :style="{fontSize: this.$common.pxToVw(this, 16)}">
        {{number}}
      </div>

      <div style="flex: 1; margin-left: 2.4rem; margin-right: 1.6rem">
        <div class="title" :style="{fontSize: this.$common.pxToVw(this, 16)}" style="text-align: left;">
          {{title}}
        </div>

        <div :class="[isHidden ? 'text hidden' : 'text']" style="text-align: left; margin-top: 1.6rem;" v-html="text" :style="{fontSize: this.$common.pxToVw(this, 14)}"/>
      </div>

      <img :src="currentChevron" width="2.2rem" height="1rem" style="width: 2.2rem; height: 1rem;">
    </div>

    <div style="height: 1px; background: #e4e4e4; margin-top: 32px;"/>
  </div>
</template>

<script>
export default {
  name: "ArcordianView",
  props: {
    number: String,
    title: String,
    text: String
  },
  data() {
    return {
      isHidden: false,
      chevronUp: require("@/assets/ic_chevron_up_pink.png"),
      chevronDown: require("@/assets/ic_chevron_down_pink.png"),
      currentChevron: null
    }
  },
  mounted() {
    this.currentChevron = this.chevronUp
  },
  methods: {

    onClickBody() {

      this.isHidden = !this.isHidden

      if (this.isHidden) {
        this.currentChevron = this.chevronDown
      } else {
        this.currentChevron = this.chevronUp
      }
    }
  }
}
</script>

<style scoped>

  .container {
    font-family: 'Noto Sans KR', sans-serif;
    display: flex;
    flex-direction: row;
  }

  .number {
    font-weight: 500;
    color: #8d00af;
  }

  .title {
    font-weight: 500;
    color: #8d00af;
  }

  .text {
    font-weight: 500;
    color: #5a5b6b;
    line-height: 1.61;
  }

  .hidden {
    display: none;
  }
</style>